import React, { useState } from 'react';
import { CaretDown } from '@phosphor-icons/react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card';
import { cn } from '../../lib/utils';

const COLUMNS = [
  { key: 'step', label: 'Step' },
  { key: 'entered', label: 'Entered' },
  { key: 'converted', label: 'Converted' },
  { key: 'dropOff', label: 'Drop-off' },
  { key: 'medianTime', label: 'Median time' },
];

export function StepTable({ title = 'Step detail', rows = [], className, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <Card className={cn('min-w-0 overflow-hidden', className)}>
      <CardHeader className="px-4 py-0">
        <button
          type="button"
          onClick={() => setOpen((value) => !value)}
          className="flex w-full items-center justify-between gap-3 py-3 text-left"
          aria-expanded={open}
        >
          <CardTitle>{title}</CardTitle>
          <span className="inline-flex items-center gap-1.5 text-[11px] font-semibold text-slate-500">
            {open ? 'Hide' : 'Show'}
            <CaretDown
              size={14}
              weight="bold"
              className={cn('transition-transform', open && 'rotate-180')}
              aria-hidden="true"
            />
          </span>
        </button>
      </CardHeader>
      {open ? (
        <CardContent className="overflow-x-auto border-t border-slate-100 px-0 py-0">
          <table className="min-w-full text-left text-sm">
            <thead className="bg-slate-50 text-[10px] font-semibold uppercase tracking-[0.12em] text-slate-500">
              <tr>
                {COLUMNS.map((column) => (
                  <th key={column.key} className="whitespace-nowrap px-4 py-2.5 font-semibold">
                    {column.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr
                  key={row.id || row.step}
                  className={cn(
                    'border-t border-slate-100',
                    row.isPending ? 'bg-amber-50/60' : 'bg-white'
                  )}
                >
                  {COLUMNS.map((column) => (
                    <td
                      key={column.key}
                      className={cn(
                        'px-4 py-3 text-slate-700',
                        column.key === 'step' && 'font-semibold text-[#201C35]',
                        column.key !== 'step' && 'tabular-nums text-[13px]'
                      )}
                    >
                      {row[column.key] ?? '—'}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </CardContent>
      ) : null}
    </Card>
  );
}
